import React, { FC, useMemo } from 'react';
import { Checkbox, Empty, Modal } from 'antd';
import { useModal } from '@@/react-hooks';
import { Gallery } from '@/ui/gallery';
import { ItemSelect, OfferSelectableItem } from '../../item-select';
import commonStyles from '../../../common.module.less';
import { OfferGroupForVerification, OfferForVerification, SpuForVerification } from '@/interface/label';

export const OffersDisplay: FC<{
  spu: SpuForVerification;
  selectedOfferGroups: OfferGroupForVerification[];
  toggleOfferGroup(offer: OfferGroupForVerification): void;
}> = ({ spu, selectedOfferGroups, toggleOfferGroup }) => {
  const offerGroups = useMemo(() => {
    const groups: OfferGroupForVerification[] = [];
    for (const offerData of spu.offers) {
      const foundGroup = groups.find(({ offerUrl }) => offerUrl === offerData.originUrl);
      if (!foundGroup) {
        groups.push({
          offerUrl: offerData.originUrl,
          offers: [offerData],
        });
      } else {
        foundGroup.offers.push(offerData);
      }
    }
    return groups;
  }, [spu]);

  const [zoomModalState, openZoomModal, closeZoomModal] = useModal<OfferForVerification>(null);

  const selectedCount = selectedOfferGroups.length;

  if (!offerGroups.length) {
    return (
      <div className={commonStyles.vertical_container}>
        <div className={commonStyles.empty}>
          <Empty description="没有找到可选 Offer" />
        </div>
      </div>
    );
  }

  return (
    <div className={commonStyles.vertical_container}>
      <header className={commonStyles.header}>
        <h3 className={commonStyles.title}>请勾选不属于当前商品的订单</h3>
        {selectedCount ? <span className={commonStyles.count}>已选中 {selectedCount} 项</span> : null}
      </header>
      <ItemSelect>
        {offerGroups.map(offerGroup => {
          const data = offerGroup.offers[0];
          const checked = selectedOfferGroups.includes(offerGroup);
          const onClick = () => toggleOfferGroup(offerGroup);
          const onZoom = () => openZoomModal(data);
          return (
            <OfferSelectableItem
              key={offerGroup.offerUrl}
              cols={2}
              checked={checked}
              spu={spu}
              data={data}
              onClick={onClick}
              onZoom={onZoom}
            >
              <Checkbox className={commonStyles.checker} checked={checked} />
            </OfferSelectableItem>
          );
        })}
      </ItemSelect>
      <Modal
        visible={zoomModalState.visible}
        onCancel={closeZoomModal}
        title={zoomModalState.data?.offerName}
        footer={null}
        width="33vw"
        mask={false}
        maskClosable={false}
      >
        {zoomModalState.visible ? <Gallery data={zoomModalState.data.images} /> : null}
      </Modal>
    </div>
  );
};
